/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAWindowIcon16Solid = forwardRef('UiCursorAWindowIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 3.75A2.75 2.75 0 0 1 4.75 1h6.5A2.75 2.75 0 0 1 14 3.75v4.071l-3.402-2.557c-1.58-1.188-3.84-.062-3.842 1.916L6.75 13h-2A2.75 2.75 0 0 1 2 10.25v-6.5Z" }),
        React.createElement("path", { d: "M8.006 7.181a1.15 1.15 0 0 1 1.841-.918l5.577 4.192c1.087.818.508 2.548-.852 2.546L12.056 13l-1.511 2.01c-.818 1.087-2.548.508-2.547-.851l.008-6.977Z" })));
});
